// extracted by mini-css-extract-plugin
module.exports = {"error":"BaseError_error__xGMB2"};